import type IEndPoint from 'interfaces/EndPointTypes';
import { AuthProtect } from '@/common/enum';

export const getPalmettoGroups = (): IEndPoint => {
  return {
    authorization: AuthProtect.NOT_REQUIRED,
    method: 'GET',
    url: 'https://palmetto-wab.s3.amazonaws.com/s3db/groups.json',
  };
};
